import { Box, Typography } from '@mui/joy';
import type { FunctionComponent, ReactNode } from 'react';

const Message: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2,
    }}
  >
    <Typography>{children}</Typography>
  </Box>
);

export default Message;
